import axios from "axios";
import * as types from '../constants/ActionTypes';
import { toast, cssTransition } from 'react-toastify';

// Url's
const saveWishlistURL = `${process.env.REACT_APP_API_URL}mobileshop/csacatalog/save-wishlist`;
const getWishlistURL = `${process.env.REACT_APP_API_URL}mobileshop/csacatalog/get-wishlist-items`;
const removeFromWishlistURL = `${process.env.REACT_APP_API_URL}mobileshop/csacatalog/delete-wishlist`;

// Actions
const wishListSuccess = data => ({
  type: types.WISHLIST_SUCCESS,
  data
});

const wishListRequested = () => ({
  type: types.WISHLIST_REQUEST
});

const wishListFailure = error => ({
  type: types.WISHLIST_FAILURE,
  error
});

const wishListUpdate = () => ({
  type: types.WISHLIST_UPDATE
});

const wishListDelete = () => ({
  type: types.WISHLIST_DELETE
});


const wishListClear = () => ({
  type: types.WISHLIST_CLEAR
});


// API
export const getWishlist = (options) => {
  // 
  return dispatch => {
    dispatch(wishListRequested());
    axios.get(getWishlistURL, {
      params: {
        connection_id: options.connection_id,
        consumer_mobile_no: options.consumer_mobile_no,
      },
    })
      .then(res => {
        if (res.data.ack === "Success") {
          // 
          dispatch(wishListSuccess(res.data.results.items));
        } else if (res.data.ack === "Failure") {
          toast.error(`Failed - ${res.data.status.message}`);
          dispatch(wishListFailure(res.data.status));
        }
      })
      .catch(err => {
        throw err;
        // dispatch(addTodoFailure(err.message));
      });
  };
};

export const clearCartInfo = (options) => {
  return dispatch => {
    dispatch(wishListClear());
  };
};

export const addToWishlist = (options) => {
    // 
  return dispatch => {
    dispatch(wishListRequested());
    axios.post(saveWishlistURL, options, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        //'Content-Type': 'application/json; charset=UTF-8'
      },
    })
      .then(res => {
        if (res.data.ack === "Success") {
        //   axios.get(cartGetURL, {
        //     params: {
        //       connection_id: options.connection_id,
        //       web_session_trans_id: options.web_session_trans_id,
        //     },
        //   })
        //     .then(res => {
        //       if (res.data.ack === "Success") {
        //         dispatch(cartInfoSuccess(res.data.results));
        //       } else if (res.data.ack === "Failure") {
        //         dispatch(cartInfoFailure(res.data.status));
        //       }
        //     })
          // dispatch(cartInfoSuccess(res.data.results));
          dispatch(wishListSuccess(res.data.results));
          toast.success("Selected Product added to Wishlist.");
        } else if (res.data.ack === "Failure") {
          // dispatch(cartInfoFailure(res.data.status));
          toast.error(`Failed - ${res.data.status.message}`);
          dispatch(wishListFailure(res.data.status));
        }
      })
      .catch(err => {
        throw err;
        // dispatch(addTodoFailure(err.message));
      });
  };
};

export const removeFromWishlist = (options) => {
  return dispatch => {
    dispatch(wishListRequested());
    axios.post(removeFromWishlistURL, options, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
        //'Content-Type': 'application/json; charset=UTF-8'
      }
    })
      .then(res => {
        if (res.data.ack === "Success") {
          dispatch(wishListDelete());
          axios.get(getWishlistURL, {
            params: {
              connection_id: options.connection_id,
              consumer_mobile_no: options.consumer_mobile_no,
            },
          })
            .then(res => {
              if (res.data.ack === "Success") {
                toast.success("Selected Product removed from Wishlist.");
                dispatch(wishListSuccess(res.data.results.items));
              } else if (res.data.ack === "Failure") {
                toast.error(`Failed - ${res.data.status.message}`);
                dispatch(wishListFailure(res.data.status));
              }
            })
          // toast.success("item removed from wishlist");
        } else if (res.data.ack === "Failure") {
          // dispatch(cartInfoFailure(res.data.status));
          toast.error(`Failed - ${res.data.status.message}`);
          dispatch(wishListFailure(res.data.status));
        }
      })
      .catch(err => {
        throw err;
        // dispatch(addTodoFailure(err.message));
      });
  };
};
